import { useCallback, useState } from "react";
import {
  attachComposerFile,
  removeComposerAttachment,
} from "@/lib/composer-attachment";
import type { ImageAttachment } from "./image-preview-strip";
import { useComposerAttachmentLifetime } from "./use-composer-attachment-lifetime";

export function useComposerAttachments() {
  const [attachments, setAttachments] = useState<ImageAttachment[]>([]);
  useComposerAttachmentLifetime(attachments, setAttachments);
  const attach = useCallback(
    (file: File) => attachComposerFile(file, setAttachments),
    [],
  );
  const remove = useCallback(
    (id: string) => removeComposerAttachment(id, setAttachments),
    [],
  );
  const clearSent = useCallback((sent: ImageAttachment[]) => {
    const ids = new Set(sent.map((attachment) => attachment.id));
    setAttachments((current) =>
      current.filter((attachment) => !ids.has(attachment.id)),
    );
  }, []);
  return { attachments, setAttachments, attach, remove, clearSent };
}
